/**
    商品列表
**/
<template>
  <div class="rightaside_content">
  <h3 class="headerTitle">{{articleItem.articleTitle}}</h3>
  <el-divider></el-divider>
    <div class="descript">
        <span><i class="el-icon-user-solid"></i> {{articleItem.createBy}}</span>
        <span><i class="el-icon-folder"></i> {{articleItem.name}}</span>
        <span><i class="el-icon-chat-round"></i> {{articleItem.articleCount}}</span>
        <span><i class="el-icon-date"></i> {{articleItem.createTime}}</span>
    </div>
    <div>
        <el-image :src="articleItem.articleImage" v-if="articleItem.articleType==1111">
            <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
            </div>
        </el-image>
        <p class="content" v-html="articleItem.articleContent"></p>
        <p class="content">文章标签：{{articleItem.articleTag}}</p>
    </div>
    <div class="commentPartEdit">
        <p>发表评论</p>
        <textarea class="el-textarea__inner" v-model="textContent" style="resize: none"></textarea>
        <!-- <el-link class="seeMore" @click="sendMsg">提交</el-link> -->
        <div style="text-align:right;">
            <el-button type="warning" class="seeMore" :disabled='isDisabled' @click="sendMsg">提交</el-button>
        </div>
    </div>
    <div class="commentPart" v-loading='loading'>
        <p>评论</p>
        <!-- 有评论就展示评论 -->
        <div class="chatcontant" v-for="(item,index) in contentList" :key="index">
            <el-card class="box-card">
                <div class="hostname">用户名:{{item.createBy}}</div>
                <div class="hostcontext">{{item.context}}</div>
                <div class="hosttime">评论时间:{{item.createTime}}</div>
            </el-card>
        </div>
        <!-- 没有评论就显示暂无评论 -->
        <div v-if="contentList.length>0?false:true">暂无评论</div>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import {helpArticle_details, addChat,getChat} from '@/api/xunyou'
import {mapMutations, mapState} from "vuex";
export default {
     inject:['reload'],
  data() {
    return {
        isDisabled:false,
        loading:false,
        articleItem:{
          id: 1,
          articleType:1,
          title: "鱼尾旗袍新款改良复古修身蕾丝中式旗袍 黄色 蕾丝",
          photos: require("@/assets/images/commend1.jpg"),
          name:'管理员',
          role:'店主之家',
          commentNum:0,
          time:'2020-10-23 00:33:22',
          content:'登陆小米网之后，在商品分类中选择您所喜爱的产品，点击进入;'
        },

     // 请求数据参数
        formInline: {
            pageSize: 10,
            pageNum: 1,
            status:0,
            muid:JSON.parse(localStorage.getItem("userdata")).userId,
        },
        // 分页参数
        pageparm:{
            pageSize:10,
            currentPage:1,
            total:0,
        },
        //文本域的内容
        textContent: "",
        contentList:[],
        userInfo:JSON.parse(localStorage.getItem('userdata'))
    };
  },
    // 注册组件
  components: {Pagination},
  /**
   * 数据发生改变
   */
  computed: {
    ...mapState(["unReadTotal"]),
    ...mapMutations(["getUnReadTotal"])
  },
  /**
   * 创建完毕
   */
  created() {},
  mounted() {
      this.getHelpArticle_details()
        //   初始化调用查询评论
        this.checkMsg()
  },
watch:{

    $route(n,o){
        if(n.fullPath !== o.fullPath){ //监听路由参数是否变化
        this.reload()
        //    this.getHelpArticle_details()  //methods中封装的加载数据函数
        }
    }

},
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      //查询评论列表
      checkMsg(){
          this.loading = true
          getChat({articleId:this.$route.query.itemId}).then(res=>{
              if(res.code==0){
                  this.loading = false
                  this.contentList = res.rows
                  console.log(this.contentList)
              }
          })
      },
      //提交评论
      sendMsg(){
          if(this.articleItem.articleReplyFlag == 'Y'){
              //如果没有输入评论内容弹出窗口提醒
                if(this.textContent==""){
                    this.$message.error("请输入评论内容")
                    return
                }
                this.isDisabled = true
                addChat({articleId:this.$route.query.itemId,context:this.textContent,createBy:this.userInfo.userId}).then(res=>{
                    console.log(res)
                    if(res.code == 0){
                        this.isDisabled = false
                        this.textContent=''
                        this.checkMsg()
                        this.$message.success({
                            message:"评论成功",
                        })
                    }else{
                        this.$message.error("评论失败,请稍后再试!")
                        this.isDisabled = false
                    }
                })
          }else{
            this.$message.info({
                message:"该文章禁止评论",
            })
          }

      },
       // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getHelpArticle_details()
    },

     // 文章（和公告）列表接口
        getHelpArticle_details(){
            helpArticle_details({articleId:this.$route.query.itemId})
                .then(res => {
                if (res.code == 0) {
                    this.articleItem = res.data;
                    localStorage.setItem("unReadTotal", res.data.unReadCount);
                    console.log("123123123"+ res.data.unReadCount);
                    this.$store.commit('getUnReadTotal',res.data.unReadCount);


                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('获取文章详情失败，请稍后再试！')
                })
        },
    //    //  个人信息加密
    // encryption(str, len) {
    //   if (str.length <= len) {
    //     return str;
    //   } else {
    //     var newStr = str.substring(0, 1);
    //     var newStrs = str.substring(str.length - 1, str.length - 2);
    //     newStr = newStr + "***" + newStrs;
    //     return newStr;
    //   }
    // },
  },
};
</script>

<style scoped lang="less">
.hostname{
    color: #333;
    font-size: 14px;
}
.hostcontext{
    font-size: 20px;
    padding: 10px 0;
}
.hosttime{
    color: #999;
    font-size: 12px;
}
.rightaside_content {
    // padding: 30px 0;
    // box-sizing: border-box;
    .headerTitle {
        font-size: 20px;
        height: 40px;
        line-height: 40px;
        color: #666;
    }
    .descript {
            padding: 0px 0 10px 0;
            color: #666;
            font-size: 14px;
            span{
                margin-right: 5px;
            }
    }
    .content {
            font-size: 14px;
            margin-bottom: 10px;
        }
    .commentPartEdit{
        p {
            font-size: 20px;
        }
        .textareaBox{
            margin: 20px 0;
        }
        .seeMore {
                padding: 10px 20px;
                border: 1px solid #eaeaea;
                background: #666;
                color: #fff;
                margin-bottom: 20px;
                margin-top: 10px;
        }
        .seeMore:hover{
            background: #78b942;
            border: 1px solid #78b942;
            color: white;
        }
    }
    .commentPart{
        p {
            font-size: 20px;
        }
    }

    .pagination{
        text-align: right;
        /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #78b942;
            color: #FFF;
            width: 20px;
        }
        /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
            width: 20px;
        }
        /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
            background-color: transparent;
        }
        }
}
</style>







// WEBPACK FOOTER //
// src/views/serviceArticle/siteHelpDetail.vue